import { render, staticRenderFns } from "./SingleChoice.vue?vue&type=template&id=698d09f9&scoped=true&lang=html&"
import script from "./SingleChoice.vue?vue&type=script&lang=js&"
export * from "./SingleChoice.vue?vue&type=script&lang=js&"
import style0 from "./SingleChoice.vue?vue&type=style&index=0&id=698d09f9&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698d09f9",
  null
  
)

export default component.exports